import { Flex } from "@/components/layout/flexbox";
import { UpgradeToPro } from "@/components/pieces/upsell/UpgradeToPro";

export function MessageGate() {
  return (
    <Flex
      px={3}
      pt={72}
      style={{
        position: "absolute",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "rgba(255,255,255,0.75)",
      }}
      justifyContent="center"
    >
      <UpgradeToPro
        benefits={[
          "Your own dedicated career coach",
          "Application strategizing",
          "Feedback at every step of the job hunt",
        ]}
        ctaType="upgrade to pro"
        ctaSource="workspace message chat"
      />
    </Flex>
  );
}
